/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity, enumeration } from '@gh/core-data';
import {
  LicenseAgreementDetailsDto,
  LicenseAgreementListItemDto,
  LicenseAgreementType,
} from './license-agreements.dto';

export const LicenseAgreementListItemMapper = entity<LicenseAgreementListItemDto>({
  systemRole: enumeration(LicenseAgreementType),
});
export const LicenseAgreementDetailsMapper = entity<LicenseAgreementDetailsDto>({
  systemRole: enumeration(LicenseAgreementType),
});
